import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const PRICING_HERO_IMG =
  '/pricingpage/pricingpagehero.webp';

const PricingPageHero = () => (
  <LogisticsPageHero
    ariaLabel="Fulfilment pricing UK"
    imageSrc={PRICING_HERO_IMG}
    imageAlt="Fulfilment pricing calculator and transparent UK 3PL rates"
    titleLight="Fulfilment Pricing UK"
    titleAccent="Transparent & Scalable"
    description={
      <>
        <p>Simple, transparent fulfilment pricing designed to grow with your business. Whether you need pick-and-pack fulfilment, warehousing, Amazon FBA prep, or a complete UK 3PL solution, our pricing is clear, predictable, and tailored to your order profile and service requirements. Use our pricing calculator or request a bespoke quote to understand your fulfilment costs with complete confidence: no hidden fees, no unexpected invoices, just straightforward pricing that scales as your business grows.</p>
        
      </>
    }
    features={[
      'Picking Fees from £0.99',
      'Next-Day Shipping from £1.99',
      '99.9% Order Accuracy',
      'Dedicated Account Manager',
      'Price Match Promise',
    ]}
    primaryCta={{ label: 'Get a custom fulfilment quote', to: '/contact-fulfillment-services' }}
  />
);

export default PricingPageHero;
